import { createRequest, platform } from "@shared/platform-api/requests"
import { createRequestHook } from "../../createRequestHook"
import { TspList } from "../../policy"

export type UseGetAllTSPsInput = { status?: "active" | "archived" }

const getAllTSPs = createRequest<UseGetAllTSPsInput, TspList>(async (input, getToken) =>
  platform(getToken).tsps.searchTsps(input)
)

export const useGetAllTSPs = createRequestHook(getAllTSPs)
